<template>
  <tab-layout>
    <li slot="tabHeading" class="nav-item">
      <a
      :class="['nav-link', selectedTab === 'details' ? 'active' : '']"
      href @click.prevent="selectedTab = 'details'" id="details-tab"
      data-toggle="tab"
      role="tab"
      aria-controls="details"
      :aria-selected="selectedTab === 'details' ? 'true' : 'false'">Details</a>
    </li>
    <li slot="tabHeading" class="nav-item" v-if="committee">
      <a
      :class="['nav-link', selectedTab === 'financials' ? 'active' : '']"
      href @click.prevent="selectedTab = 'financials'" id="financials-tab"
      data-toggle="tab"
      role="tab"
      aria-controls="financials"
      :aria-selected="selectedTab === 'financials' ? 'true' : 'false'">Financials</a>
    </li>
    <li slot="tabHeading" class="nav-item" v-if="committee">
      <a
      :class="['nav-link', selectedTab === 'secretaries' ? 'active' : '']"
      href @click.prevent="selectedTab = 'secretaries'" id="secretaries-tab"
      data-toggle="tab"
      role="tab"
      aria-controls="secretaries"
      :aria-selected="selectedTab === 'secretaries' ? 'true' : 'false'">Secretaries</a>
    </li>
    <li slot="tabHeading" class="nav-item" v-if="committee && committee.affiliations.length > 0 && committee.affiliations[0].is_completed == true">
      <a
      :class="['nav-link', selectedTab === 'affiliations' ? 'active' : '']"
      href @click.prevent="selectedTab = 'affiliations'" id="affiliations-tab"
      data-toggle="tab"
      role="tab"
      aria-controls="affiliations"
      :aria-selected="selectedTab === 'affiliations' ? 'true' : 'false'">Affiliations</a>
    </li>
    <committee-profile-all-details
      v-if="selectedTab === 'details'"
      :committeeDetails="committee"
      :isLoading="isLoading"
      @renew="renew = true;selectedTab = 'details'"
      slot="tabContent"
      class="tab-pane row mx-0 show active"
      id="details"
      role="tabpanel"
      aria-labelledby="details-tab" />
    <committee-profile-financials
      v-if="committee  && selectedTab === 'financials'"
      v-bind:committeeId="committee.id"
      slot="tabContent"
      class="tab-pane col-12 col-xl-9 px-0 bg-white rounded mb-4 p-3 p-sm-4 show active"
      id="financials"
      role="tabpanel"
      aria-labelledby="financials-tab" />
    <committee-secretaries
      v-if="committee  && selectedTab === 'secretaries'"
      :committeeDetails="committee"
      slot="tabContent"
      class="tab-pane col-12 col-xl-9 px-0 bg-white rounded mb-4 p-3 p-sm-4 show active"
      id="secretaries"
      role="tabpanel"
      aria-labelledby="secretaries-tab" />
    <committee-affiliation
      v-if="committee  && selectedTab === 'affiliations'"
      :committeeDetails="committee"
      slot="tabContent"
      class="tab-pane row mx-0 show active"
      id="affiliations"
      role="tabpanel"
      aria-labelledby="affiliations-tab" />
    <div
      v-if="selectedTab === 'loading'"
      slot="tabContent"
      class="tab-pane col-12 col-xl-9 px-0 bg-white rounded mb-4 p-3 p-sm-4 show active"
      id="loading"
      role="tabpanel"
      aria-labelledby="loading-tab">
        <div class="spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div>
    </div>
  </tab-layout>
</template>

<script>
/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */

import axios from 'axios'
import tabLayout from '@/components/TabLayout'
import committeeSecretaries from './components/CommitteeSecretaries'
import CommitteeAffiliation from "./components/CommitteeAffiliation"
import committeeProfileAllDetails from "./CommitteeProfileAllDetails"
import committeeProfileFinancials from "./components/CommitteeProfileFinancials"

export default {
  name: 'CommitteeProfile',
  props: ['details', 'id'],
  components: {
    'tab-layout': tabLayout,
    'committee-profile-all-details': committeeProfileAllDetails,
    'committee-profile-financials': committeeProfileFinancials,
    'committee-secretaries': committeeSecretaries,
    'committee-affiliation': CommitteeAffiliation
  },
  data() {
    return {
      committee: null,
      isLoading: true,
      selectedTab: this.tabSelect ? this.tabSelect : 'details'
    }
  },
  mounted() {
    const committeeId = this.id || (this.details && (this.details.committee ? this.details.committee.id : this.details.id))
    if (committeeId) {
      axios.get(`${this.$api}/admin/committee-details/${committeeId}`)
        .then((response) => {
          this.committee = response.data.data
          this.isLoading = false
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
          this.isLoading = false
        })
    } else {
      this.isLoading = false
    }
  },
  watch: {
    committee() {
      if (this.selectedTab === 'loading') {
        this.selectedTab = 'details'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Committees/Profile/CommitteeProfile.vue